/**
 * Whether the locale typically uses the Latin alphabet (e.g. en-US, de-DE).
 */
export function isLatinScriptLocale(
  locale: string | null | undefined
): boolean {
  if (!locale) {
    return false;
  }

  try {
    return new Intl.Locale(locale).maximize().script === 'Latn';
  } catch {
    return false;
  }
}
